import { USER } from '../../assets/constants/strings';
import { updateUserUsage } from '../../services/axios';
import { UPDATE_USER } from '../User/userTypes';
import {
  CANCEL_SUBSCRIPTION,
  CLEAN_UPDATE_SUBSCRIPTION,
  GET_PADDLE_PRICES,
  GET_PADDLE_PRODUCTS,
  GET_USER_PAYMENT_METHOD,
  GET_USER_TRANSACTIONS,
  SET_PADDLE_LOADING,
  SET_UPDATE_SUBSCRIPTION,
  UPDATE_PAYMENT_METHOD,
  UPDATE_SUBSCRIPTION,
} from './paddleTypes';

const REGCITY_PRICEID = 'pro_01hshrxrfdwym5ew3n1s5kmhcm';
const BASE_URL = 'https://regcity-staging-paddle-api.azurewebsites.net';

export const setLoading = () => ({
  type: SET_PADDLE_LOADING,
});

export const SetUpdateSubscription = () => ({
  type: SET_UPDATE_SUBSCRIPTION,
});

export const CleanUpdateSubscription = () => ({
  type: CLEAN_UPDATE_SUBSCRIPTION,
});

export const GetPaddleProducts = () => {
  return async (dispatch, getState) => {
    dispatch(setLoading());

    fetch(`${BASE_URL}/paddle-products`)
      .then(async (data) => {
        const response = await data.json();
        dispatch({
          type: GET_PADDLE_PRODUCTS,
          payload: response.data.filter((item) => item.id === REGCITY_PRICEID),
        });
      })
      .catch((error) => {
        console.error('ERROR getting products from paddle:', error);
        dispatch({
          type: GET_PADDLE_PRODUCTS,
          payload: [],
        });
      });
  };
};

export const GetPaddlePrices = () => {
  return async (dispatch, getState) => {
    dispatch(setLoading());

    fetch(`${BASE_URL}/paddle-prices`)
      .then(async (data) => {
        const response = await data.json();
        dispatch({
          type: GET_PADDLE_PRICES,
          payload: response.data.filter(
            (item) => item.product_id === REGCITY_PRICEID
          ),
        });
      })
      .catch((error) => {
        console.error('ERROR getting prices from paddle:', error);
        dispatch({
          type: GET_PADDLE_PRICES,
          payload: [],
        });
      });
  };
};

export const GetPaddleUSer = async (userEmail) => {
  let paddleUser = [];

  try {
    await fetch(`${BASE_URL}/paddle-user/${userEmail}`)
      .then(async (data) => {
        const response = await data.json();
        paddleUser = response.data;
      })
      .catch((error) => {
        console.error('ERROR getting user from paddle:', error);
      });
  } catch (error) {
    console.error('ERROR getting user from paddle:', error);
  }

  return paddleUser[0];
};

export const GetPaddleUSerSubscription = async (userPaddleId) => {
  let userSubscription = [];

  try {
    await fetch(`${BASE_URL}/paddle-subscriptions/${userPaddleId}`)
      .then(async (data) => {
        const response = await data.json();
        userSubscription = response.data;
      })
      .catch((error) => {
        console.error('ERROR getting user subscription from paddle:', error);
      });
  } catch (error) {
    console.error('ERROR getting user subscription from paddle:', error);
  }

  return userSubscription[0];
};

export const GetPaddleUSerAddress = async (userPaddleId) => {
  let address = [];

  try {
    await fetch(`${BASE_URL}/paddle-user-address/${userPaddleId}`)
      .then(async (data) => {
        const response = await data.json();
        address = response.data;
      })
      .catch((error) => {
        console.error('ERROR getting user address from paddle:', error);
      });
  } catch (error) {
    console.error('ERROR getting user address from paddle:', error);
  }

  if (address.length > 1) {
    address.sort((a, b) =>
      new Date(a.created_at) < new Date(b.created_at) ? 1 : -1
    );
    return address[0];
  } else return address[0];
};

export const UpdatePaddleSubscription = (
  subscriptionId,
  customerPaddleId,
  userAddressId,
  currency,
  priceId
) => {
  return async (dispatch, getState) => {
    let userSubscription = {};
    dispatch(setLoading());

    try {
      await fetch(
        `${BASE_URL}/paddle-update-subscription/${subscriptionId}/${customerPaddleId}/${userAddressId}/${currency}/${priceId}`,
        {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
        }
      )
        .then(async (data) => {
          // console.log('response', data);

          if (data && data.status === 200) {
            let user = getState().user.user;

            const response = await data.json();
            userSubscription = data;
            // console.log(response);

            const paddleUserSubs = response.data;
            user = {
              ...user,
              userPlan: {
                ...user.userPlan,
                subscriptionID: paddleUserSubs.id,
                subscriptionName: paddleUserSubs.items[0].price.name,
                billingPeriod:
                  paddleUserSubs.billing_cycle.interval === 'month'
                    ? 'Monthly'
                    : '',
                price: paddleUserSubs.items[0].price.unit_price.amount / 100,
                currency: paddleUserSubs.currency_code,
                status: paddleUserSubs.status,
                startedAt: paddleUserSubs.started_at
                  ? new Date(paddleUserSubs.started_at)
                      .toLocaleTimeString([], {
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric',
                      })
                      .split('at')[0]
                      .trim()
                  : '',
                nextBilling: paddleUserSubs.next_billed_at
                  ? new Date(paddleUserSubs.next_billed_at)
                      .toLocaleTimeString([], {
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric',
                      })
                      .split('at')[0]
                      .trim()
                  : '',
              },
            };
            dispatch({
              type: UPDATE_USER,
              payload: user,
            });
            dispatch({
              type: UPDATE_SUBSCRIPTION,
            });
          }
        })
        .catch((error) => {
          console.error('ERROR updating user subscription from paddle:', error);
          dispatch({
            type: UPDATE_SUBSCRIPTION,
          });
        });
    } catch (error) {
      console.error('ERROR updating user subscription from paddle:', error);
      dispatch({
        type: UPDATE_SUBSCRIPTION,
      });
    }

    return userSubscription;
  };
};

export const GetPaddleUserTransactions = (userPaddleId, loading = true) => {
  return async (dispatch, getState) => {
    if (loading) dispatch(setLoading());

    try {
      await fetch(`${BASE_URL}/paddle-user-transactions/${userPaddleId}`)
        .then(async (data) => {
          if (data && data.status === 200) {
            const response = await data.json();

            if (response && response.data && response.data.length > 0) {
              dispatch({
                type: GET_USER_TRANSACTIONS,
                payload: response.data,
              });

              const paymentMethod = response.data.filter(
                (item) => item.payments.length > 0
              );
              dispatch({
                type: GET_USER_PAYMENT_METHOD,
                payload: paymentMethod[0].payments[0].method_details,
              });
            } else {
              dispatch({
                type: GET_USER_TRANSACTIONS,
                payload: [],
              });
            }
          }
        })
        .catch((error) => {
          console.error('ERROR getting user transactions from paddle:', error);
          dispatch({
            type: GET_USER_TRANSACTIONS,
            payload: [],
          });
        });
    } catch (error) {
      console.error('ERROR getting user transactions from paddle:', error);
      dispatch({
        type: GET_USER_TRANSACTIONS,
        payload: [],
      });
    }
  };
};

export const CancelUserSubscription = (subscriptionId) => {
  return async (dispatch, getState) => {
    dispatch(setLoading());
    let res = {};

    try {
      await fetch(`${BASE_URL}/paddle-cancel-subscription/${subscriptionId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      })
        .then(async (data) => {
          // console.log('data', data);
          const response = await data.json();
          res = response.data;
          // console.log(res);

          dispatch({
            type: CANCEL_SUBSCRIPTION,
          });
        })
        .catch((error) => {
          console.error(
            'ERROR cancelling user subscription from paddle:',
            error
          );
          dispatch({
            type: CANCEL_SUBSCRIPTION,
          });
        });
      return (res = { ...res, success: true });
    } catch (error) {
      console.error('ERROR cancelling user subscription from paddle:', error);
      dispatch({
        type: CANCEL_SUBSCRIPTION,
      });
      return (res = { ...res, success: false });
    }
  };
};

export const UpdatePaymentMethod = (subscriptionId) => {
  return async (dispatch, getState) => {
    dispatch(setLoading());
    let res = [];
    // let user = getState().user.user;

    try {
      await fetch(
        `${BASE_URL}/paddle-update-payment-method/${subscriptionId}`,
        {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        }
      )
        .then(async (data) => {
          // console.log('data', data);
          const response = await data.json();
          res = response.data;
          // console.log(res);

          dispatch({
            type: UPDATE_PAYMENT_METHOD,
          });
        })
        .catch((error) => {
          console.error('ERROR updating payment method from paddle:', error);
          dispatch({
            type: UPDATE_PAYMENT_METHOD,
          });
        });
    } catch (error) {
      console.error('ERROR updating payment method from paddle:', error);
      dispatch({
        type: UPDATE_PAYMENT_METHOD,
      });
    }

    return res;
  };
};

export const UpdateUserUsage = (type) => {
  return async (dispatch, getState) => {
    let user = getState().user.user;

    const data = {
      userId: user.userID,
      clientId: user.userClient.id,
      featureUsed: type,
      planId: user.userClient.planId,
    };
    // update user usage database
    const res = await updateUserUsage(data, user.token);
    // console.log('res', res);

    let remainingPageViews = user.remainingPageViews;
    let remainingQueries = user.remainingQueries;
    let remainingSummaries = user.remainingSummaries;
    let remainingShares = user.remainingShares;
    let remainingAdditionalQueries = user.remainingAdditionalQueries;

    if (type === USER.USAGE.PAGEVIEWS)
      remainingPageViews = user.remainingPageViews - 1;
    else if (type === USER.USAGE.QUERIES)
      remainingQueries = user.remainingQueries - 1;
    else if (type === USER.USAGE.SUMMARIES)
      remainingSummaries = user.remainingSummaries - 1;
    else if (type === USER.USAGE.SHARES)
      remainingShares = user.remainingShares - 1;
    else if (type === USER.USAGE.ADDITIONALQUERIES)
      remainingAdditionalQueries = user.remainingAdditionalQueries - 1;

    if (res) {
      user = {
        ...user,
        remainingPageViews: remainingPageViews,
        remainingQueries: remainingQueries,
        remainingSummaries: remainingSummaries,
        remainingShares: remainingShares,
        remainingAdditionalQueries: remainingAdditionalQueries,
        userUsage: {
          ...user.userUsage,
          [type]: user.userUsage[type] + 1,
        },
      };

      dispatch({
        type: UPDATE_USER,
        payload: user,
      });
    }
  };
};

export const GetPaddleDiscountById = async (discountId) => {
  let discount = {};

  try {
    await fetch(`${BASE_URL}/paddle-discounts/${discountId}`)
      .then(async (data) => {
        const response = await data.json();
        discount = response.data;
      })
      .catch((error) => {
        console.error('ERROR getting user discount from paddle:', error);
      });
  } catch (error) {
    console.error('ERROR getting user discount from paddle:', error);
  }

  return discount;
};
